/* LUYA · Lista de deseos
   - Corazón en cada tarjeta de producto y en la ficha de producto (rojo al marcar).
   - Icono de corazón con contador en la cabecera (celular y PC) que abre la lista.
   - Se guarda en el navegador de cada visitante: localStorage + cookie (respaldo). */
(function () {
  if (window.__luyaWishlist) return;
  window.__luyaWishlist = true;

  var KEY = 'luyaWishlist';
  var COOKIE = 'luya_wishlist';
  var RED = '#D62839';
  var WHATSAPP = '51944227778';
  var WA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 2.9 2.9 0 0 0-.9 2.2 5 5 0 0 0 1 2.7 11.5 11.5 0 0 0 4.4 3.9c1.6.7 2.3.8 3.1.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.5-.3z"/></svg>';
  var SHARE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M16 6l-4-4-4 4M12 2v13"/></svg>';
  var HEART ='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.6s-7.6-4.7-9.6-9.3C1 8 2.9 4.5 6.4 4.1c2.1-.2 3.9.9 5.6 3 1.7-2.1 3.5-3.2 5.6-3 3.5.4 5.4 3.9 4 7.2-2 4.6-9.6 9.3-9.6 9.3z"/></svg>';

  /* ---------- almacenamiento ---------- */
  function readCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    if (!m) return [];
    try { return decodeURIComponent(m[1]).split('|').filter(Boolean); } catch (e) { return []; }
  }
  function writeCookie(handles) {
    var v = encodeURIComponent(handles.join('|'));
    document.cookie = COOKIE + '=' + v + '; path=/; max-age=' + 60 * 60 * 24 * 365 + '; SameSite=Lax';
  }
  function load() {
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { list = []; }
    if (!list.length) {
      list = readCookie().map(function (h) { return { handle: h }; });
    }
    return list;
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    writeCookie(list.map(function (i) { return i.handle; }));
    render();
  }
  var items = load();
  function has(handle) { return items.some(function (i) { return i.handle === handle; }); }

  /* ---------- datos de producto ---------- */
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return 'S/ ' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function fetchProduct(handle) {
    return fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        return { handle: handle, title: p.title, url: root + 'products/' + handle, img: img, price: p.price, varies: p.price_varies };
      });
  }
  function hydrateMissing() {
    var missing = items.filter(function (i) { return !i.title; });
    if (!missing.length) return;
    Promise.all(missing.map(function (m) {
      return fetchProduct(m.handle).then(function (d) { Object.assign(m, d); }).catch(function () { m.gone = true; });
    })).then(function () {
      items = items.filter(function (i) { return !i.gone; });
      save(items);
    });
  }
  function toggle(handle, btn) {
    if (has(handle)) {
      items = items.filter(function (i) { return i.handle !== handle; });
      save(items);
      toast('Quitado de tu lista de deseos');
    } else {
      items.push({ handle: handle });
      save(items);
      if (btn) { btn.classList.remove('lw-pop'); void btn.offsetWidth; btn.classList.add('lw-pop'); }
      toast('Guardado en tu lista de deseos ♥');
      fetchProduct(handle).then(function (d) {
        items = items.map(function (i) { return i.handle === handle ? d : i; });
        save(items);
      }).catch(function () {});
    }
  }

  /* ---------- estilos ---------- */
  var css = '' +
    '.lw-heart{position:absolute;top:8px;right:8px;z-index:4;width:38px;height:38px;border-radius:50%;border:0;background:rgba(255,255,255,.92);box-shadow:0 2px 8px rgba(0,0,0,.12);display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;transition:transform .2s ease,background .2s ease}' +
    '.lw-heart svg{width:20px;height:20px;fill:none;stroke:#2A2420;stroke-width:1.7;transition:fill .25s ease,stroke .25s ease}' +
    '.lw-heart:hover{transform:scale(1.08)}' +
    '.lw-heart[aria-pressed="true"] svg{fill:' + RED + ';stroke:' + RED + '}' +
    '.lw-heart.lw-pop{animation:lwPop .45s cubic-bezier(.2,.7,.2,1.4)}' +
    '@keyframes lwPop{0%{transform:scale(1)}40%{transform:scale(1.32)}100%{transform:scale(1)}}' +
    '.lw-heart--inline{position:static;width:44px;height:44px;flex:0 0 44px;margin-left:10px;box-shadow:none;border:1px solid #e3d9c8}' +
    '.lw-title-row{display:flex;align-items:flex-start;justify-content:space-between;gap:8px}' +
    '.lw-header-btn{position:relative;display:flex;align-items:center;justify-content:center;width:44px;height:44px;background:none;border:0;cursor:pointer;color:currentColor;padding:0}' +
    '.lw-header-btn svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1.6}' +
    '.lw-header-btn.has-items svg{fill:' + RED + ';stroke:' + RED + '}' +
    '.header__icon.lw-header-btn span.lw-count{position:absolute!important;top:2px!important;right:-4px!important;bottom:auto!important;left:auto!important;height:16px!important;min-width:16px;width:auto!important;padding:0 4px!important;border-radius:999px!important;background:#fff!important;color:' + RED + '!important;box-shadow:0 0 0 1px ' + RED + ';font-size:9px!important;font-weight:700;line-height:16px!important;text-align:center}' +
    '.lw-count[hidden]{display:none}' +
    '.lw-drawer{position:fixed;inset:0;z-index:1001;visibility:hidden}' +
    '.lw-drawer.is-open{visibility:visible}' +
    '.lw-drawer__bg{position:absolute;inset:0;background:rgba(20,14,8,.45);opacity:0;transition:opacity .3s ease}' +
    '.lw-drawer.is-open .lw-drawer__bg{opacity:1}' +
    '.lw-drawer__panel{position:absolute;top:0;right:0;bottom:0;width:min(420px,92vw);background:#fff;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .35s cubic-bezier(.2,.7,.2,1);box-shadow:-10px 0 30px rgba(0,0,0,.12)}' +
    '.lw-drawer.is-open .lw-drawer__panel{transform:none}' +
    '.lw-drawer__head{display:flex;align-items:center;justify-content:space-between;padding:20px 22px;border-bottom:1px solid #eee5d6}' +
    '.lw-drawer__head h2{margin:0;font:400 24px/1.2 Georgia,serif;color:#8C6A40}' +
    '.lw-drawer__x{background:none;border:0;font-size:30px;line-height:1;cursor:pointer;color:#2A2420}' +
    '.lw-drawer__list{flex:1;overflow:auto;padding:8px 22px;margin:0;list-style:none}' +
    '.lw-item{display:grid;grid-template-columns:76px 1fr auto;gap:14px;align-items:center;padding:14px 0;border-bottom:1px solid #f1ebe0}' +
    '.lw-item img{width:76px;height:76px;object-fit:cover;border-radius:4px;background:#f6f2ea}' +
    '.lw-item a{color:#2A2420;text-decoration:none;font-size:14px;line-height:1.35;display:block}' +
    '.lw-item a:hover{color:#8C6A40}' +
    '.lw-item__price{font-size:13px;color:#8C6A40;margin-top:4px}' +
    '.lw-item__rm{background:none;border:0;cursor:pointer;color:#8a847a;font-size:12px;text-decoration:underline;padding:4px}' +
    '.lw-empty{text-align:center;padding:48px 10px;color:#5f5a52;font-size:14px;line-height:1.6}' +
    '.lw-empty svg{width:40px;height:40px;fill:none;stroke:#C9A66B;stroke-width:1.4;margin-bottom:10px}' +
    '.lw-drawer__foot{padding:16px 22px 20px;border-top:1px solid #eee5d6;display:flex;flex-direction:column;gap:10px}' +
    '.lw-btn{display:flex;align-items:center;justify-content:center;gap:8px;min-height:48px;border-radius:2px;font-size:12px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;text-decoration:none;cursor:pointer;border:0;padding:0 16px}' +
    '.lw-btn[hidden]{display:none}' +
    '.lw-btn svg{width:18px;height:18px}' +
    '.lw-btn--wa{background:#1F8A4C;color:#fff}.lw-btn--wa:hover{background:#18723E}' +
    '.lw-btn--main{background:#C9A66B;color:#2A2118}' +
    '.lw-btn--ghost{background:#fff;color:#2A2420;border:1px solid #d9cdb8}' +
    '.lw-note{margin:2px 0 0;font-size:11.5px;line-height:1.5;color:#8a847a;text-align:center}' +
    '.lw-item__buy{display:inline-block!important;margin-top:8px;padding:7px 12px;background:#C9A66B;color:#2A2118!important;font-size:11px!important;font-weight:600;letter-spacing:.08em;text-transform:uppercase;border-radius:2px}' +
    '.lw-item__buy:hover{background:#B8935C}' +
    '.lw-item__saved{font-size:12px;color:' + RED + ';white-space:nowrap}' +
    '.lw-toast{position:fixed;left:50%;bottom:24px;z-index:1002;transform:translate(-50%,20px);opacity:0;background:#2A2420;color:#fff;font-size:13px;padding:11px 18px;border-radius:22px;transition:all .3s ease;pointer-events:none;white-space:nowrap}' +
    '.lw-toast.is-on{opacity:1;transform:translate(-50%,0)}' +
    '@media(max-width:749px){.lw-heart{width:34px;height:34px;top:6px;right:6px}.lw-heart svg{width:18px;height:18px}.lw-header-btn{width:40px}}' +
    '@media(prefers-reduced-motion:reduce){.lw-heart.lw-pop{animation:none}.lw-drawer__panel,.lw-drawer__bg,.lw-toast{transition:none}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* ---------- aviso ---------- */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'lw-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1800);
  }

  /* ---------- panel de la lista ---------- */
  var drawer = document.createElement('div');
  drawer.className = 'lw-drawer';
  drawer.setAttribute('aria-hidden', 'true');
  drawer.innerHTML = '<div class="lw-drawer__bg" data-lw-close></div>' +
    '<aside class="lw-drawer__panel" role="dialog" aria-modal="true" aria-label="Lista de deseos">' +
    '<div class="lw-drawer__head"><h2>Mi lista de deseos</h2><button type="button" class="lw-drawer__x" data-lw-close aria-label="Cerrar">×</button></div>' +
    '<ul class="lw-drawer__list"></ul>' +
    '<div class="lw-drawer__foot">' +
      '<a class="lw-btn lw-btn--wa" data-lw-wa target="_blank" rel="noopener">' + WA + 'Pedir mi lista por WhatsApp</a>' +
      '<button type="button" class="lw-btn lw-btn--ghost" data-lw-share>' + SHARE + 'Compartir mi lista</button>' +
      '<button type="button" class="lw-btn lw-btn--main" data-lw-saveall hidden>Guardar todo en mi lista</button>' +
      '<p class="lw-note">Elige talla o piedra en cada joya y paga con tarjeta, Yape o Plin. Tu lista se guarda en este navegador.</p>' +
    '</div></aside>';
  function openDrawer() { hydrateMissing(); render(); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function closeDrawer() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; if (shared) { shared = null; render(); } }
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-lw-close]')) closeDrawer();
    var rm = e.target.closest('[data-lw-remove]');
    if (rm) toggle(rm.getAttribute('data-lw-remove'));
    var add = e.target.closest('[data-lw-add]');
    if (add) toggle(add.getAttribute('data-lw-add'));
    if (e.target.closest('[data-lw-share]')) shareList();
    if (e.target.closest('[data-lw-saveall]') && shared) {
      shared.forEach(function (s) { if (!has(s.handle)) items.push(s); });
      save(items);
      toast('Guardamos estas joyas en tu lista ♥');
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function render() {
    /* contador de cabecera */
    document.querySelectorAll('.lw-header-btn').forEach(function (b) {
      var c = b.querySelector('.lw-count');
      c.textContent = items.length;
      c.hidden = !items.length;
      b.classList.toggle('has-items', !!items.length);
      b.setAttribute('aria-label', 'Lista de deseos (' + items.length + ')');
    });
    /* corazones */
    document.querySelectorAll('.lw-heart').forEach(function (b) {
      var on = has(b.getAttribute('data-handle'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Quitar de mi lista de deseos' : 'Agregar a mi lista de deseos');
    });
    /* panel */
    var list = shared || items;
    drawer.querySelector('.lw-drawer__head h2').textContent = shared ? 'Lista de deseos compartida' : 'Mi lista de deseos';
    drawer.querySelector('[data-lw-saveall]').hidden = !shared || !shared.length;
    drawer.querySelector('[data-lw-share]').hidden = !!shared || !items.length;
    var wa = drawer.querySelector('[data-lw-wa]');
    wa.hidden = !list.length;
    wa.href = 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent(waText(list));
    var ul = drawer.querySelector('.lw-drawer__list');
    if (!list.length) {
      ul.innerHTML = '<li class="lw-empty">' + HEART + '<br>Aún no guardas ninguna joya.<br>Toca el corazón en las que te gusten para verlas aquí.</li>';
      return;
    }
    ul.innerHTML = list.map(function (i) {
      var url = esc(i.url || root + 'products/' + i.handle);
      var img = i.img ? i.img + (i.img.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var action = shared
        ? (has(i.handle) ? '<span class="lw-item__saved">♥ En tu lista</span>' : '<button type="button" class="lw-item__rm" data-lw-add="' + esc(i.handle) + '">Guardar</button>')
        : '<button type="button" class="lw-item__rm" data-lw-remove="' + esc(i.handle) + '">Quitar</button>';
      return '<li class="lw-item">' +
        '<a href="' + url + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(i.title || '') + '" loading="lazy">' : '<span></span>') + '</a>' +
        '<div><a href="' + url + '">' + esc(i.title || 'Cargando…') + '</a>' +
        (i.price != null ? '<div class="lw-item__price">' + (i.varies ? 'Desde ' : '') + money(i.price) + '</div>' : '') +
        '<a class="lw-item__buy" href="' + url + '">Elegir y comprar</a></div>' +
        action + '</li>';
    }).join('');
  }

  /* ---------- WhatsApp y compartir ---------- */
  var origin = location.origin;
  var NL = String.fromCharCode(10);
  function waText(list) {
    var lines = list.map(function (i, n) {
      return (n + 1) + '. ' + (i.title || i.handle) + (i.price != null ? ' (' + (i.varies ? 'desde ' : '') + money(i.price) + ')' : '') + NL + origin + (i.url || root + 'products/' + i.handle);
    });
    return '¡Hola LUYA! Quiero comprar estas joyas de mi lista de deseos:' + NL + NL + lines.join(NL + NL) + NL + NL + '¿Me ayudan con tallas y forma de pago?';
  }
  function shareLink() {
    return origin + root + '?lista=' + encodeURIComponent(items.map(function (i) { return i.handle; }).join(','));
  }
  function shareList() {
    var url = shareLink();
    var data = { title: 'Mi lista de deseos LUYA', text: 'Mira las joyas que me gustan de LUYA ♥', url: url };
    if (navigator.share) { navigator.share(data).catch(function () {}); return; }
    try { navigator.clipboard.writeText(url).then(function () { toast('Enlace copiado. Pégalo donde quieras compartirlo'); }); }
    catch (e) { window.prompt('Copia este enlace:', url); }
  }
  var shared = null;
  function openShared(handles) {
    shared = handles.map(function (h) { return { handle: h }; });
    openDrawer();
    Promise.all(shared.map(function (s) {
      return fetchProduct(s.handle).then(function (d) { Object.assign(s, d); }).catch(function () { s.gone = true; });
    })).then(function () {
      shared = shared.filter(function (s) { return !s.gone; });
      render();
    });
  }

  /* ---------- botón de cabecera ---------- */
  function addHeaderButton() {
    document.querySelectorAll('.header__icons').forEach(function (icons) {
      if (icons.querySelector('.lw-header-btn')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lw-header-btn header__icon link focus-inset';
      b.innerHTML = HEART + '<span class="lw-count" hidden>0</span>';
      b.addEventListener('click', openDrawer);
      var cart = icons.querySelector('#cart-icon-bubble, .header__icon--cart');
      if (cart) icons.insertBefore(b, cart); else icons.appendChild(b);
    });
  }

  /* ---------- corazones en tarjetas ---------- */
  function handleFromHref(href) {
    var part = (href || '').split('/products/')[1];
    if (!part) return null;
    part = part.split('?')[0].split('#')[0].split('/')[0];
    try { return decodeURIComponent(part) || null; } catch (e) { return part || null; }
  }
  function makeHeart(handle, inline) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lw-heart' + (inline ? ' lw-heart--inline' : '');
    b.setAttribute('data-handle', handle);
    b.innerHTML = HEART;
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(handle, b); });
    return b;
  }
  function addCardHearts(scope) {
    (scope || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('.lw-heart')) return;
      var a = card.querySelector('a[href*="/products/"]');
      var handle = a && handleFromHref(a.getAttribute('href'));
      if (!handle) return;
      var host = card.querySelector('.card__inner') || card.querySelector('.card') || card;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(makeHeart(handle));
    });
  }

  /* ---------- corazón en la ficha de producto ---------- */
  function addProductHeart() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var handle = handleFromHref(location.pathname);
    if (!handle || document.querySelector('.lw-heart--inline')) return;
    var title = document.querySelector('.product__title h1, .product__title, main h1');
    if (!title) return;
    var wrap = title.closest('.product__title') || title;
    var row = document.createElement('div');
    row.className = 'lw-title-row';
    wrap.parentNode.insertBefore(row, wrap);
    row.appendChild(wrap);
    row.appendChild(makeHeart(handle, true));
  }

  function init() {
    document.body.appendChild(drawer);
    addHeaderButton();
    addCardHearts();
    addProductHeart();
    render();
    hydrateMissing();
    /* enlace de lista compartida: luya18k.com/?lista=handle1,handle2 */
    var q = new URLSearchParams(location.search).get('lista');
    if (q) {
      var hs = q.split(',').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 40);
      if (hs.length) openShared(hs);
    }
    /* tarjetas que aparecen después (filtros, carruseles, búsqueda) */
    var pending = false;
    new MutationObserver(function (muts) {
      var need = muts.some(function (m) {
        if (!m.addedNodes || !m.addedNodes.length) return false;
        var t = m.target;
        return !(t.closest && t.closest('.lw-drawer, .lw-header-btn, .lw-heart, .lw-toast'));
      });
      if (!need || pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        addCardHearts(); addHeaderButton(); render();
      });
    }).observe(document.body, { childList: true, subtree: true });
    /* otra pestaña cambió la lista */
    window.addEventListener('storage', function (e) { if (e.key === KEY) { items = load(); render(); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
